import { VueRouter } from 'vue-router/types/router'

export class RouteQuery {
  private router: VueRouter
  private query = {}

  constructor (router: VueRouter) {
    this.router = router
  }

  push (newQuery: { [key: string]: any }) {
    this.query = {
      ...this.query,
      ...newQuery
    }
    return this.release()
  }

  private async release () {
    if (this.noChanges) return
    const query = {}
    Object.assign(query, this.router.currentRoute.query)
    Object.assign(query, this.query)
    // remove all undefined states
    Object.keys(query).forEach(k => {
      if (query[k]) return
      delete query[k]
    })
    const newPath = this.router.resolve({ query })
    console.log({ newPath })
    if (this.router.currentRoute.fullPath !== newPath.route.fullPath) {
      try {
        return await this.router.push({ query })
      } catch (e) {
        console.warn('Router:', e.message)
      }
    }

  }

  private get hasChanges () {
    return JSON.stringify(this.router.currentRoute.query) !== JSON.stringify(this.query)
  }

  private get noChanges () {
    return !this.hasChanges
  }

  private prepareData (data) {
    return Object.keys(data).reduce((current, key) => {
      if (data[key] === 'true') {
        current[key] = true
      }
      else if (data[key] === 'false') {
        current[key] = false
      }
      else {
        current[key] = data[key]
      }
      return current
    }, {} as Record<string, any>)
  }
}
